export default __webpack_public_path__ + "static/media/product_pref1.ed39987d20458e5db3acbbc3b3680e02.svg";